import type {RefObject} from 'react';
import {useEffect, useState} from 'react';
import {registerDropTarget} from '@Libraries/canvas-item-drag.library';

/**
 * Registers the element behind `elementRef` as a drop target for pointer-driven tile drags (`beginTileDrag`)
 * under `targetId`, and reports whether a drag is currently hovering it so the component can light up.
 */
export const useDropTarget = (targetId: string, elementRef: RefObject<HTMLElement | null>): boolean => {
  const [isDragHoveringTarget, setIsDragHoveringTarget] = useState(false);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) {
      return undefined;
    }
    return registerDropTarget(targetId, {element, onHoverChange: setIsDragHoveringTarget});
  }, [targetId]);

  return isDragHoveringTarget;
};
